import ko from "knockout";
import SplashScreen from "./SplashScreen";
import viewHtml from "./SplashScreen.html";

export function mount() {
    const splashAchorElement = document.getElementById("splashAnchorPlace");

    const parsedNodes = ko.utils.parseHtmlFragment(viewHtml);
    ko.virtualElements.setDomNodeChildren(splashAchorElement, parsedNodes);

    const instance = new SplashScreen();
    ko.applyBindings(instance, splashAchorElement.firstElementChild);
}

export function unmount() {
    const splashAchorElement = document.getElementById("splashAnchorPlace");

    window.requestAnimationFrame(() => {
        splashAchorElement.style.display = "none";
        ko.cleanNode(splashAchorElement);
    });
}
